import React from 'react';
import { CommentStart, CommentEnd } from '../comments';
import { useConfig } from '../config-context';
import { useWidth } from '../width-context';
import { WrapperInnerNestedDiv } from './wrapper-inner-nested-div';
export function WrapperInnerDiv(props) {
    var backgroundUrl = props.backgroundUrl, children = props.children, padding = props.padding;
    var width = useWidth().width;
    var renderComments = useConfig().renderComments;
    return (React.createElement("div", { style: {
            margin: '0px auto',
            maxWidth: width + "px",
        } },
        React.createElement(WrapperInnerNestedDiv, { backgroundUrl: backgroundUrl },
            React.createElement("table", { align: "center", border: "0", cellPadding: "0", cellSpacing: "0", role: "presentation", style: { width: '100%' } },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", { style: {
                                direction: 'ltr',
                                fontSize: '0px',
                                padding: padding,
                                textAlign: 'center',
                            } }, renderComments ? (React.createElement(React.Fragment, null,
                            React.createElement(CommentStart, null),
                            React.createElement("table", { role: "presentation", border: "0", cellPadding: "0", cellSpacing: "0" },
                                React.createElement(CommentEnd, null),
                                children,
                                React.createElement(CommentStart, null)),
                            React.createElement(CommentEnd, null))) : (children))))))));
}
//# sourceMappingURL=wrapper-inner-div.js.map